var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-card", { staticClass: "mb5" }, [
        _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "formSearch",
                attrs: {
                  model: _vm.queryForm,
                  "label-position": "top",
                  size: "small",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { staticClass: "select-label" },
                          [
                            _c(
                              "template",
                              { slot: "label" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "postcodeType-class",
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "orderDetails.pleaseChoose"
                                      ),
                                    },
                                    on: { change: _vm.clearNameCode },
                                    model: {
                                      value: _vm.siteChangeType,
                                      callback: function ($$v) {
                                        _vm.siteChangeType = $$v
                                      },
                                      expression: "siteChangeType",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      key: "1",
                                      attrs: {
                                        label: _vm.$t(
                                          "collectionCenter.siteName"
                                        ),
                                        value: 1,
                                      },
                                    }),
                                    _c("el-option", {
                                      key: "2",
                                      attrs: {
                                        label: _vm.$t(
                                          "collectionCenter.siteNum"
                                        ),
                                        value: 2,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.siteChangeType === 1
                              ? _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "collectionCenter.pleaseInput"
                                    ),
                                  },
                                  on: {
                                    blur: function ($event) {
                                      return _vm.siteBlur("name")
                                    },
                                    input: _vm.changeSite,
                                  },
                                  model: {
                                    value: _vm.queryForm.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.queryForm, "name", $$v)
                                    },
                                    expression: "queryForm.name",
                                  },
                                })
                              : _vm._e(),
                            _vm.siteChangeType === 2
                              ? _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "collectionCenter.pleaseInput"
                                    ),
                                  },
                                  on: {
                                    blur: function ($event) {
                                      return _vm.siteBlur("code")
                                    },
                                    input: _vm.changeSite,
                                  },
                                  model: {
                                    value: _vm.queryForm.code,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.queryForm, "code", $$v)
                                    },
                                    expression: "queryForm.code",
                                  },
                                })
                              : _vm._e(),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("collectionCenter.stateZT"),
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "collectionCenter.pleaseChoose"
                                  ),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.queryForm.siteStatus,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryForm, "siteStatus", $$v)
                                  },
                                  expression: "queryForm.siteStatus",
                                },
                              },
                              _vm._l(_vm.StatusList, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.siteStatusName,
                                    value: item.siteStatus,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("collectionCenter.businessModel"),
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "collectionCenter.pleaseChoose"
                                  ),
                                  clearable: "",
                                  size: "small",
                                },
                                model: {
                                  value: _vm.queryForm.businessModel,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryForm,
                                      "businessModel",
                                      $$v
                                    )
                                  },
                                  expression: "queryForm.businessModel",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t(
                                      "collectionCenter.directSales"
                                    ),
                                    value: 1,
                                  },
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("collectionCenter.joinSales"),
                                    value: 2,
                                  },
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("collectionCenter.exclusive"),
                                    value: 3,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("collectionCenter.dotType"),
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "collectionCenter.pleaseChoose"
                                  ),
                                  clearable: "",
                                  size: "small",
                                },
                                model: {
                                  value: _vm.queryForm.siteType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryForm, "siteType", $$v)
                                  },
                                  expression: "queryForm.siteType",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("collectionCenter.tudo"),
                                    value: null,
                                  },
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("collectionCenter.hut"),
                                    value: 1,
                                  },
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("collectionCenter.dot"),
                                    value: 2,
                                  },
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t(
                                      "collectionCenter.transferCenter"
                                    ),
                                    value: 3,
                                  },
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t(
                                      "collectionCenter.headOffice"
                                    ),
                                    value: 4,
                                  },
                                }),
                                _c("el-option", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.activeNameTab === "kuaidi",
                                      expression: "activeNameTab === 'kuaidi'",
                                    },
                                  ],
                                  attrs: {
                                    label: _vm.$t(
                                      "collectionCenter.supportBranch"
                                    ),
                                    value: 6,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("collectionCenter.contractSigned"),
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "placeOrder.pleaseChoose"
                                  ),
                                  clearable: "",
                                  filterable: "",
                                },
                                model: {
                                  value: _vm.queryForm.contractSigned,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryForm,
                                      "contractSigned",
                                      $$v
                                    )
                                  },
                                  expression: "queryForm.contractSigned",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("GlobalSetObj.yes"),
                                    value: 1,
                                  },
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("GlobalSetObj.No"),
                                    value: 0,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("collectionCenter.region") },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "placeOrder.pleaseChoose"
                                  ),
                                  clearable: "",
                                  "collapse-tags": "",
                                  filterable: "",
                                  multiple: "",
                                },
                                model: {
                                  value: _vm.queryForm.regionIds,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryForm, "regionIds", $$v)
                                  },
                                  expression: "queryForm.regionIds",
                                },
                              },
                              _vm._l(_vm.regionList, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    label:
                                      item.zhName + "（" + item.puName + "）",
                                    value: item.id,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("collectionCenter.stateSite1"),
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "multiple-limit": 50,
                                  placeholder: _vm.$t(
                                    "GlobalSetObj.pleaseChoose"
                                  ),
                                  clearable: "",
                                  "collapse-tags": "",
                                  filterable: "",
                                  multiple: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.changeState(1)
                                  },
                                },
                                model: {
                                  value: _vm.queryForm.stateList,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryForm, "stateList", $$v)
                                  },
                                  expression: "queryForm.stateList",
                                },
                              },
                              _vm._l(_vm.StateList, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    label: item.label,
                                    value: item.label,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("collectionCenter.citySite"),
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "formTable",
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "multiple-limit": 50,
                                  placeholder: _vm.$t(
                                    "placeOrder.pleaseChoose"
                                  ),
                                  "remote-method": function (name) {
                                    return _vm.getSenderCity(name, 1)
                                  },
                                  "collapse-tags": "",
                                  filterable: "",
                                  multiple: "",
                                  remote: "",
                                  "reserve-keyword": "",
                                },
                                on: {
                                  "visible-change": function ($event) {
                                    return _vm.getSenderCity("", 1)
                                  },
                                },
                                model: {
                                  value: _vm.queryForm.cityList,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryForm, "cityList", $$v)
                                  },
                                  expression: "queryForm.cityList",
                                },
                              },
                              _vm._l(_vm.cityList, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: { label: item.name, value: item.name },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "collectionCenter.owningTransitCenter1"
                              ),
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "GlobalSetObj.pleaseChoose"
                                  ),
                                  clearable: "",
                                  filterable: "",
                                },
                                model: {
                                  value: _vm.queryForm.departmentId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryForm, "departmentId", $$v)
                                  },
                                  expression: "queryForm.departmentId",
                                },
                              },
                              _vm._l(
                                _vm.departmentList,
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { staticClass: "select-label" },
                          [
                            _c(
                              "template",
                              { slot: "label" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "postcodeType-class",
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "orderDetails.pleaseChoose"
                                      ),
                                    },
                                    on: { change: _vm.postcodeTypeChange },
                                    model: {
                                      value: _vm.postcodeType,
                                      callback: function ($$v) {
                                        _vm.postcodeType = $$v
                                      },
                                      expression: "postcodeType",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      key: "1",
                                      attrs: {
                                        label: _vm.$t(
                                          "collectionCenter.smallParcelPostcode"
                                        ),
                                        value: 1,
                                      },
                                    }),
                                    _c("el-option", {
                                      key: "2",
                                      attrs: {
                                        label: _vm.$t(
                                          "collectionCenter.largeParcelPostcode"
                                        ),
                                        value: 2,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "collectionCenter.pleaseInput"
                                ),
                              },
                              on: { input: _vm.handleChangePostCode },
                              model: {
                                value: _vm.postCode,
                                callback: function ($$v) {
                                  _vm.postCode = $$v
                                },
                                expression: "postCode",
                              },
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "select-label",
                            attrs: {
                              label: _vm.$t("collectionCenter.postcodeState"),
                            },
                          },
                          [
                            _c(
                              "template",
                              { slot: "label" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "GlobalSetObj.pleaseChoose"
                                      ),
                                    },
                                    model: {
                                      value: _vm.queryForm.zipCodeBusinessType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryForm,
                                          "zipCodeBusinessType",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "queryForm.zipCodeBusinessType",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      key: 2,
                                      attrs: {
                                        label: _vm.$t(
                                          "collectionCenter.StateOfSmallPostcode"
                                        ),
                                        value: 3,
                                      },
                                    }),
                                    _c("el-option", {
                                      key: 1,
                                      attrs: {
                                        label: _vm.$t(
                                          "collectionCenter.StateOfLargePostcode"
                                        ),
                                        value: 4,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "multiple-limit": 50,
                                  placeholder: _vm.$t(
                                    "GlobalSetObj.pleaseChoose"
                                  ),
                                  clearable: "",
                                  "collapse-tags": "",
                                  filterable: "",
                                  multiple: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.changeState(2)
                                  },
                                },
                                model: {
                                  value: _vm.queryForm.zipCodeStateList,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryForm,
                                      "zipCodeStateList",
                                      $$v
                                    )
                                  },
                                  expression: "queryForm.zipCodeStateList",
                                },
                              },
                              _vm._l(_vm.StateList, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    label: item.label,
                                    value: item.label,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "select-label",
                            attrs: {
                              label:
                                _vm.queryForm.zipCodeBusinessType === 3
                                  ? _vm.$t(
                                      "collectionCenter.CityOfSmallPostcode"
                                    )
                                  : _vm.$t(
                                      "collectionCenter.CityOfLargePostcode"
                                    ),
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "formTable",
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "multiple-limit": 50,
                                  placeholder: _vm.$t(
                                    "placeOrder.pleaseChoose"
                                  ),
                                  "remote-method": function (name) {
                                    return _vm.getSenderCity(name, 2)
                                  },
                                  "collapse-tags": "",
                                  filterable: "",
                                  multiple: "",
                                  remote: "",
                                  "reserve-keyword": "",
                                },
                                on: {
                                  "visible-change": function ($event) {
                                    return _vm.getSenderCity("", 2)
                                  },
                                },
                                model: {
                                  value: _vm.queryForm.zipCodeCityList,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryForm,
                                      "zipCodeCityList",
                                      $$v
                                    )
                                  },
                                  expression: "queryForm.zipCodeCityList",
                                },
                              },
                              _vm._l(_vm.cityList2, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: { label: item.name, value: item.name },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit:remove",
                                value:
                                  "btn:collection-center:basicDate:site:search",
                                expression:
                                  "'btn:collection-center:basicDate:site:search'",
                                arg: "remove",
                              },
                            ],
                            attrs: {
                              icon: "el-icon-search",
                              size: "small",
                              type: "primary",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.searchResources(1)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("operationCenter.Procurar")) + " "
                            ),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit:remove",
                                value:
                                  "btn:collection-center:basicDate:site:reset",
                                expression:
                                  "'btn:collection-center:basicDate:site:reset'",
                                arg: "remove",
                              },
                            ],
                            attrs: {
                              icon: "el-icon-refresh-left",
                              size: "small",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.searchResources(2)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("operationCenter.reset")) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit:remove",
                                value:
                                  "btn:collection-center:basicDate:site:allExport",
                                expression:
                                  "'btn:collection-center:basicDate:site:allExport'",
                                arg: "remove",
                              },
                            ],
                            staticStyle: { "margin-left": "10px" },
                            attrs: { size: "small", type: "primary" },
                            on: { click: _vm.exportDateDimension },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("collectionCenter.allExport")) + " "
                            ),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit:remove",
                                value:
                                  "btn:collection-center:basicDate:site:add",
                                expression:
                                  "'btn:collection-center:basicDate:site:add'",
                                arg: "remove",
                              },
                            ],
                            staticStyle: { "margin-left": "10px" },
                            attrs: { size: "small", type: "primary" },
                            on: { click: _vm.newSiteBtn },
                          },
                          [_vm._v(_vm._s(_vm.$t("collectionCenter.add")) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-card",
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClickTab },
              model: {
                value: _vm.activeNameTab,
                callback: function ($$v) {
                  _vm.activeNameTab = $$v
                },
                expression: "activeNameTab",
              },
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("collectionCenter.lanshou"),
                    name: "lanshou",
                  },
                },
                [
                  _c(
                    "virtual-scroll",
                    {
                      ref: "virtualScroll",
                      attrs: {
                        data: _vm.tableData,
                        "item-size": 76,
                        "key-prop": "id",
                      },
                      on: {
                        change: function (virtualList) {
                          return (_vm.list = virtualList)
                        },
                      },
                    },
                    [
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.list,
                            "header-cell-style": {
                              background: "#f2f2f2",
                              color: "black",
                            },
                            "tree-props": {
                              children: "children",
                              hasChildren: "hasChildren",
                            },
                            height: "600",
                            "row-key": "id",
                            stripe: "",
                          },
                        },
                        [
                          _c("virtual-column", {
                            attrs: {
                              label: _vm.$t("userManage.realName"),
                              "min-width": "220",
                              prop: "name",
                              type: "tree",
                            },
                          }),
                          _vm._l(_vm.headerList, function (item, ind) {
                            return _c(
                              "el-table-column",
                              {
                                key: ind,
                                attrs: {
                                  align: item.align,
                                  "min-width": item.width,
                                  prop: item.prop,
                                  "show-overflow-tooltip": true,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          item.prop === "status"
                                            ? _c(
                                                "div",
                                                [
                                                  scope.row.status === 1
                                                    ? _c("el-tag", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              scope.row
                                                                .statusName
                                                            ) +
                                                            " "
                                                        ),
                                                      ])
                                                    : scope.row.status === 0
                                                    ? _c(
                                                        "el-tag",
                                                        {
                                                          attrs: {
                                                            type: "danger",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row
                                                                .statusName
                                                            ) + " "
                                                          ),
                                                        ]
                                                      )
                                                    : scope.row.status === 2
                                                    ? _c(
                                                        "el-tag",
                                                        {
                                                          attrs: {
                                                            type: "info",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row
                                                                .statusName
                                                            ) + " "
                                                          ),
                                                        ]
                                                      )
                                                    : _c("span"),
                                                ],
                                                1
                                              )
                                            : _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      scope.row[item.prop] || ""
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("template", { slot: "header" }, [
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "center" } },
                                    [_vm._v(_vm._s(item.label))]
                                  ),
                                ]),
                              ],
                              2
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("collectionCenter.operation"),
                              align: "center",
                              fixed: "right",
                              width: "100",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.createTime
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  size: "small",
                                                  type: "text",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.seeDetial(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("basicData.View")
                                                  ) + " "
                                                ),
                                              ]
                                            ),
                                            scope.row.siteType !== 4
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "permit",
                                                        rawName:
                                                          "v-permit:remove",
                                                        value:
                                                          "btn:collection-center:basicDate:site:edit",
                                                        expression:
                                                          "'btn:collection-center:basicDate:site:edit'",
                                                        arg: "remove",
                                                      },
                                                    ],
                                                    attrs: {
                                                      size: "small",
                                                      type: "text",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.editSite(
                                                          scope.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "GlobalSetObj.edit"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("collectionCenter.expressDelivery"),
                    name: "kuaidi",
                  },
                },
                [
                  _c(
                    "virtual-scroll",
                    {
                      ref: "virtualScroll",
                      attrs: {
                        data: _vm.tableData,
                        "item-size": 76,
                        "key-prop": "id",
                      },
                      on: {
                        change: function (virtualList) {
                          return (_vm.list = virtualList)
                        },
                      },
                    },
                    [
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.list,
                            "header-cell-style": {
                              background: "#f2f2f2",
                              color: "black",
                            },
                            "tree-props": {
                              children: "children",
                              hasChildren: "hasChildren",
                            },
                            height: "600px",
                            "row-key": "id",
                            stripe: "",
                          },
                        },
                        [
                          _c("virtual-column", {
                            attrs: {
                              label: _vm.$t("userManage.realName"),
                              "min-width": "220",
                              prop: "name",
                              type: "tree",
                            },
                          }),
                          _vm._l(_vm.headerList, function (item, ind) {
                            return _c(
                              "el-table-column",
                              {
                                key: ind,
                                attrs: {
                                  align: item.align,
                                  "min-width": item.width,
                                  prop: item.prop,
                                  "show-overflow-tooltip": true,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          item.prop === "status"
                                            ? _c(
                                                "div",
                                                [
                                                  scope.row.status === 1
                                                    ? _c("el-tag", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              scope.row
                                                                .statusName
                                                            ) +
                                                            " "
                                                        ),
                                                      ])
                                                    : scope.row.status === 0
                                                    ? _c(
                                                        "el-tag",
                                                        {
                                                          attrs: {
                                                            type: "danger",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row
                                                                .statusName
                                                            ) + " "
                                                          ),
                                                        ]
                                                      )
                                                    : scope.row.status === 2
                                                    ? _c(
                                                        "el-tag",
                                                        {
                                                          attrs: {
                                                            type: "info",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row
                                                                .statusName
                                                            ) + " "
                                                          ),
                                                        ]
                                                      )
                                                    : _c("span"),
                                                ],
                                                1
                                              )
                                            : _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      scope.row[item.prop] || ""
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("template", { slot: "header" }, [
                                  _c("div", [_vm._v(_vm._s(item.label))]),
                                ]),
                              ],
                              2
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("collectionCenter.operation"),
                              fixed: "right",
                              width: "100",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.createTime
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  size: "small",
                                                  type: "text",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.seeDetial(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("basicData.View")
                                                  ) + " "
                                                ),
                                              ]
                                            ),
                                            scope.row.siteType !== 4
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "permit",
                                                        rawName:
                                                          "v-permit:remove",
                                                        value:
                                                          "btn:collection-center:basicDate:site:edit",
                                                        expression:
                                                          "'btn:collection-center:basicDate:site:edit'",
                                                        arg: "remove",
                                                      },
                                                    ],
                                                    attrs: {
                                                      size: "small",
                                                      type: "text",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.editSite(
                                                          scope.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "GlobalSetObj.edit"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("new-site", {
        key: _vm.newSiteKey,
        ref: "newSiteRef",
        on: { reSearch: _vm.reSearch },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }